import { ComponentFactoryResolver, Directive, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewContainerRef } from '@angular/core'
import { LogosLinkComponent } from '../logos-link/logos-link.component'
import { ReactiveSearchComponent } from '../reactive-search/reactive-search.component'

const componentMapper = {
  search: ReactiveSearchComponent,
  header_seals: LogosLinkComponent
}

@Directive({
  selector: '[dynamicsModule]'
})
export class DynamicsModuleDirective implements OnInit, OnChanges {

  @Input() module
  @Input() searchResult
  @Input() identifier: any
  @Input() detailLayout: any
  @Input() inSlide
  componentRef: any
  @Output() notSupportedEmitter = new EventEmitter()
  @Output() clearResult = new EventEmitter()
  @Output() close = new EventEmitter()
  @Output() search = new EventEmitter()
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()

  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.componentRef) {
      this.componentRef.instance.result = this.searchResult
    }
  }

  ngOnInit() {
    if (componentMapper[this.module?.component]) {
      const factory = this.resolver.resolveComponentFactory(
        componentMapper[this.module.component]
      )
      this.componentRef = this.container.createComponent(factory)
      this.componentRef.instance.identifier = this.identifier
      this.componentRef.instance.module = this.module
      this.componentRef.instance.clearResult = this.clearResult
      this.componentRef.instance.search = this.search
      this.componentRef.instance.close = this.close
      this.componentRef.instance.inSlide = this.inSlide
      this.componentRef.instance.result = this.searchResult
      this.componentRef.instance.page = this.page
    } else {
      this.notSupportedEmitter.emit(this.module)
    }
  }

}
